// Types
const ADD_DOCUMENT = 'ADD_DOCUMENT'
const DELETE_DOCUMENT = 'DELETE_DOCUMENT'
const MARK_DOCUMENTS_UPLOADED = 'MARK_DOCUMENTS_UPLOADED'
const RESET_DOCUMENTS = 'RESET_DOCUMENTS'

// Actions
export const addDocument = (rowId, document) => {
  return {
    type: ADD_DOCUMENT,
    rowId,
    document,
  }
}

export const deleteDocument = (rowId, documentIdx) => {
  return {
    type: DELETE_DOCUMENT,
    rowId,
    documentIdx,
  }
}

export const resetDocs = () => {
  return {
    type: RESET_DOCUMENTS,
  }
}

export const markDocumentsUploaded = rowId => {
  return {
    type: MARK_DOCUMENTS_UPLOADED,
    rowId,
  }
}

//
// Reducers
//
export default (state = {}, action) => {
  let newState
  switch (action.type) {
    case ADD_DOCUMENT: {
      newState = { ...state }
      const _rowId = action.rowId.toString()
      if (action.rowId in newState) newState[_rowId].push(action.document)
      else newState[_rowId] = [action.document]
      return newState
    }
    case DELETE_DOCUMENT:
      newState = { ...state }
      if (newState[action.rowId].length > 1) newState[action.rowId].splice(action.documentIdx, 1)
      else delete newState[action.rowId]
      return newState
    case RESET_DOCUMENTS:
      return {}
    case MARK_DOCUMENTS_UPLOADED: {
      const rowId = action.rowId.toString()
      const docs = state[rowId]
      if (!docs) return state
      return {
        ...state,
        [rowId]: docs.map(doc => (doc.uploaded ? doc : { ...doc, uploaded: true })),
      }
    }
    default:
      return state
  }
}

export const documentsActions = {
  addDocument,
  deleteDocument,
  markDocumentsUploaded,
  resetDocs,
}
